export default __webpack_public_path__ + "static/pedals-white-c4eedc72d8323bf309abf60d0791d493.svg";